import { paymentsAPI } from '../api/client';
import { apiError } from './host';

const SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';
let loading = null;

/** Loads Razorpay Checkout once. */
function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  loading ||= new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SCRIPT;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => { loading = null; reject(new Error('Could not load Razorpay. Check your connection and try again.')); };
    document.body.appendChild(s);
  });
  return loading;
}

/**
 * Pays an invoice: an order from TeleCalX, Razorpay Checkout (card, UPI, net banking, wallet), then TeleCalX checks the
 * result. Resolves {status: 'paid', ...} or {status: 'cancelled'}; rejects with a readable message.
 */
export async function payInvoice(invoiceId) {
  let order;
  try {
    [order] = await Promise.all([paymentsAPI.order(invoiceId).then((r) => r.data), loadCheckout()]);
  } catch (err) {
    throw new Error(err.response ? apiError(err) : err.message);
  }
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: order.amount,
      currency: order.currency,
      name: order.name,
      description: order.description,
      prefill: order.prefill,
      notes: order.notes,
      theme: { color: '#079765' },
      handler: (result) => {
        paymentsAPI.verify(result).then((r) => resolve({ ...r.data, status: 'paid' })).catch((err) => reject(new Error(apiError(err))));
      },
      modal: { ondismiss: () => resolve({ status: 'cancelled' }) },
    });
    // A failed attempt stays inside Checkout, which shows the reason and lets the customer try again.
    rzp.open();
  });
}
